module.exports = __webpack_public_path__ + "static/media/style-tiles.09e0f3fa.jpg";